import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IContentComponent } from 'src/app/interfaces/content-component.interface';
import { ContentService } from 'src/app/services/content.service';
import { TitleService } from 'src/app/services/title.service';

@Component({
  selector: 'app-introduction',
  templateUrl: './introduction.component.html',
  styleUrls: ['./introduction.component.scss']
})
export class IntroductionComponent implements OnInit, OnDestroy, IContentComponent {

  private componentDestroyed = new Subject();

  pageComponentName: string = 'Introduction';  
  data!: Map<string, string>;

  showMoreInfoText: boolean = false;

  isLinear = false;
  firstFormGroup!: FormGroup;
  secondFormGroup!: FormGroup;

  constructor(    
    private contentService: ContentService, private router: Router, private titleService: TitleService) {

    this.titleService.setTitle("Finansklagenemnda - Klageskjema");

    this.contentService.content
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(
        (data: Map<string, string>) => {
          if (data !== undefined) {
            this.data = data;
          }
        }
      );

    this.contentService.loadContent('pageText', this.pageComponentName, ['text', 'label']);

  }

  getLabelValue(label:string): string {
    let value: string = '';
    if (this.data) {
      value = this.data.get(label) ?? '';
    }
    return value;
  }

  ngOnInit(): void {

  }

  ngOnDestroy(): void {
    this.componentDestroyed.next(null);
    this.componentDestroyed.unsubscribe();
  }

  navigate(url: string): void {
    this.router.navigateByUrl(url);
  }

  toggleMoreInfoText() {
    this.showMoreInfoText = !this.showMoreInfoText;
  }
}

